import { welcomeScreenUI, unitsFontFamily, unitsRight, unitsInactiveFontWeight } from "../../configs";
import { findBrandByDomain } from "../../configs/configLoader";

import "./index.css";

interface TextFieldComponentProps {
  option1: string;
  option2: string;
  unit: string;
  handleUnitChange: (newUnit: string) => void;
  placeholder1?: string;
  placeholder2?: string;
}

const UnitOptions: React.FC<TextFieldComponentProps> = ({
  option1,
  option2,
  unit,
  handleUnitChange,
  placeholder1,
  placeholder2,
}) => {
  const brandDefined = findBrandByDomain();

  const urlParameters = new URLSearchParams(window.location.search);
  const countryCode = urlParameters.get("countryCode");

  const isVB = brandDefined?.name === "Victoria Beckham";
  const isVelour = brandDefined?.name === "Velour Garments";
  const isDevernois = brandDefined?.name === "Devernois";

  const isDevernoisEU = isDevernois && countryCode === "EU";

  const unitsStyles = {
    fontWeight: welcomeScreenUI.units.fontWeight,
    fontSize: welcomeScreenUI.units.fontSize,
    textTransform: (welcomeScreenUI.units as any)?.textTransform,
    fontFamily: unitsFontFamily,
    fontStyle: "normal",
    border: !isVB && !isVelour ? "none" : "1px solid #000000",
    padding: isVelour ? "5px" : !isVB ? "none" : "10px",
  };

  const getVictoriaBeckhamStyles = (unit: string, option: string) => {
    return {
      color:
        unit === option
          ? welcomeScreenUI.units.inactiveColor
          : welcomeScreenUI.units.activeColor,
      backgroundColor:
        unit === option
          ? welcomeScreenUI.units.activeColor
          : welcomeScreenUI.units.inactiveColor,
    };
  };

  const victoriaStylesFirst =
    isVB || isVelour ? getVictoriaBeckhamStyles(unit, option1) : {};

  const victoriaStylesSecond =
    isVB || isVelour ? getVictoriaBeckhamStyles(unit, option2) : {};

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    option: string,
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleUnitChange(option);
    }
  };

  const handleAreaUnitMap = () => {
    switch (unit) {
      case "cm":
      case "feet":
        return "height-unit-announcement";
      case "kg":
      case "lbs":
        return "weight-unit-announcement";
      case "year":
      case "month":
        return "age-unit-announcement";
      default:
        return "";
    }
  };

  const containerStyle: React.CSSProperties = {
    display: "flex",
    gap: !isVB && !isVelour ? "10px" : 0,
    position: "absolute",
    right: unitsRight,
    top: 0,
    bottom: 0,
    alignItems: "center",
  };

  return (
    <div
      className="unit-options"
      role="radiogroup"
      style={containerStyle}
    >
      <span
        tabIndex={0}
        role="radio"
        aria-describedby={handleAreaUnitMap()}
        aria-checked={unit === option1}
        style={{
          ...unitsStyles,
          color:
            unit === option1
              ? welcomeScreenUI.units.activeColor
              : welcomeScreenUI.units.inactiveColor,
          cursor: "pointer",
          textDecoration:
            unit === option1
              ? (welcomeScreenUI?.units as { activeFontStyle?: string })
                  ?.activeFontStyle || ""
              : "",
          fontWeight:
            unit !== option1
              ? unitsInactiveFontWeight
              : unitsStyles.fontWeight,
          ...victoriaStylesFirst,
        }}
        onClick={() => handleUnitChange(option1)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
          handleKeyDown(e, option1)
        }
      >
        {placeholder1 ? placeholder1 : option1}
      </span>
      {!isDevernoisEU ? (
        <span
          tabIndex={0}
          role="radio"
          aria-describedby={handleAreaUnitMap()}
          aria-checked={unit === option2}
          style={{
            ...unitsStyles,
            color:
              unit === option2
                ? welcomeScreenUI.units.activeColor
                : welcomeScreenUI.units.inactiveColor,
            cursor: "pointer",
            textDecoration:
              unit === option2
                ? (welcomeScreenUI?.units as { activeFontStyle?: string })
                    ?.activeFontStyle || ""
                : "",
            fontWeight:
              unit !== option2
                ? unitsInactiveFontWeight
                : unitsStyles.fontWeight,
            ...victoriaStylesSecond,
          }}
          onClick={() => handleUnitChange(option2)}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
            handleKeyDown(e, option2)
          }
        >
          {placeholder2 ? placeholder2 : option2}
        </span>
      ) : null}
    </div>
  );
};

export default UnitOptions;
